module.exports = __webpack_public_path__ + "static/media/distance_horizontal_icon.a50761f5.svg";